import { FC, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { ResourceCategory } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { SelectField } from '@mews-commander/form';
import { TextKey } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { FormFields, FormValues } from '../../../schema';

interface SpaceCategoryFieldProps {
    data?: ResourceCategory[];
    isEditMode: boolean;
}

export const SpaceCategoryField: FC<SpaceCategoryFieldProps> = ({ data, isEditMode }) => {
    const { setValue, clearErrors } = useFormContext<FormValues>();

    const options = useMemo(() => data?.map(({ id, name }) => createOption({ value: id, label: name })) ?? [], [data]);

    useEffect(() => {
        if (!isEditMode) {
            setValue(FormFields.PromotedResourceCategoryId, options?.[0]?.value || '', { shouldValidate: true });
        }

        return () => clearErrors();
    }, [options, setValue, clearErrors, isEditMode]);

    return (
        <SelectField
            name={FormFields.PromotedResourceCategoryId}
            options={options}
            label={lt(TextKey.PromotedResourceCategory)}
            showEmptyValue={false}
        />
    );
};
